module.exports = __webpack_public_path__ + "img/sksw.74d5f4da.jpg";